import { Injectable, Injector } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { ReportSeriesFacetGeneratorOutput } from '../../Common/Reports/models/report-series-facet-generator-output.model';
import { MentionsSearchResponseModel } from '../../api/mentions/model/mentions-search-response.model';
import { ReportSeriesMentionRequestGeneratorOutput } from '../../Common/Reports/models/report-series-mention-request-generator-output.model';
import { SearchCriteriaModel } from '../../api/mentions/model/search-criteria.model';
import { DataPointModel } from '../../Common/Charts/models/data-point.model';
import { Mention } from '../../Common/Mentions/models/mention';
import { ReportSeriesModel } from '../../Common/Reports/models/report-series.model';
import { ChartMetricsEnum } from '../../Common/Reports/enums/chart-metrics.enum';
import { MentionsApi } from '../../api/mentions/mentions.api';
import { DiscoverListsFilterService } from '../../Common/Filter/services/discover-lists-filter.service';
import { SavedFilterService } from '../../Common/Filter/services/saved-filter.service';
import { JournodexRegionsService } from '../../Common/Journodex/services/journodex-regions.service';
import { MonitorConfigService } from '../../Common/MonitorShared/services/monitor-config.service';
import { ReportsSeriesMapperService } from '../../Common/Reports/services/reports-series-mapper.service';
import { SourceGroupService } from '../../Common/Sources/services/source-group.service';
import { TagGroupsService } from '../../Common/Tags/services/tag-groups.service';
import { TagsService } from '../../Common/Tags/services/tags.service';
import { IndexeddbCoreCacheService } from '../../Core/Cache/services/indexeddb-core-cache.service';
import { LocalizationService } from '../../Core/Localization/services/localization.service';
import { CurrencyConversionService } from '../../Core/Users/services/currency-conversion.service';
import { CurrentUserStateService } from '../../Core/Users/services/current-user-state.service';
import { AbstractDashboardSearchService } from '../../Monitor/Core/services/abstract-dashboard-search.service';
import { VISeriesTypesEnum } from '../enums/vi-series-types.enum';

export interface IndividualReportSeriesConfig {
    type: VISeriesTypesEnum;
    dynamicKey?: string;
    label?: string;
    metric?: ChartMetricsEnum;
    metrics?: ChartMetricsEnum[];
    isPreviousPeriod?: boolean;
    mentionProvider?: BehaviorSubject<Mention[]>;
    facetGenerator?(): ReportSeriesFacetGeneratorOutput;
    dataMapper?(response: MentionsSearchResponseModel, request?: SearchCriteriaModel, series?: ReportSeriesModel): DataPointModel[];
    asyncDataMapper?(response: MentionsSearchResponseModel, request?: SearchCriteriaModel, series?: ReportSeriesModel): Observable<DataPointModel[]>;
    mentionRequestGenerator?(): ReportSeriesMentionRequestGeneratorOutput;
    mentionDataMapper?(response: MentionsSearchResponseModel): Mention[];
}

/**
 * This service handles all facet search and mapping functionality. For other functionalities, go to MonitoringAnalyticsDashboardService
 */
@Injectable()
export class ViReportsSearchService extends AbstractDashboardSearchService {

    constructor(
        protected tagsService: TagsService,
        protected tagGroupsService: TagGroupsService,
        protected journodexService: JournodexRegionsService,
        protected mentionsApi: MentionsApi,
        protected currentUserStateService: CurrentUserStateService,
        protected reportSeriesMapperService: ReportsSeriesMapperService,
        protected sourceGroupService: SourceGroupService,
        protected localizationService: LocalizationService,
        protected currencyConversionService: CurrencyConversionService,
        protected monitorConfigService: MonitorConfigService,
        protected savedFilterService: SavedFilterService,
        protected discoverListsFilterService: DiscoverListsFilterService,
        protected injector: Injector,
        protected cacheService: IndexeddbCoreCacheService
    ) {
        super(
            tagsService,
            tagGroupsService,
            journodexService,
            mentionsApi,
            currentUserStateService,
            reportSeriesMapperService,
            sourceGroupService,
            localizationService,
            currencyConversionService,
            monitorConfigService,
            savedFilterService,
            discoverListsFilterService,
            injector,
            cacheService
        );
    }
}
